/** 👇 [ID]
 * file ini hanya bisa trigger untuk reload jika versi berubah di broser
 * di local variable VUE_APP_VERSION akan tetap sama, tapi akan selalu di update ketika di deploy
 * versi otomatis terupdate lewat gitlab-ci.yaml stage compile_app sebelum proses build
 * setup output filename unik ketika build ada di vue.config.js agar ketika build mencantumkan versi aplikasi pada nama file
 * - gitlab-ci.yaml
 * - vue.config.js
 * - versioning.js
 * */

const currentVersion = process.env.VUE_APP_VERSION
const savedVersion = localStorage.getItem('version')

if (savedVersion !== currentVersion) {
	console.log('===> new version', currentVersion)
  localStorage.setItem('version', currentVersion)
  window.location.reload(true)
} else {
	console.log('===> version', currentVersion)
}
